module.exports = __webpack_public_path__ + "static/img/live_type05.1f3f2bc8.png";